import React from 'react';
import { DeckOffer } from './DeckReshuffle';

export type Freshness = 'fresh' | 'aging' | 'stale' | 'syncing';

export interface OfferCardProps {
  merchant: string;
  logo?: string;
  category: DeckOffer['category'];
  value: string;
  freshness: Freshness;
  expiresIn?: string;
  expiringSoon?: boolean;
  saved?: boolean;
  onToggleSave?: () => void;
}

const FRESH_LABEL: Record<Freshness, string> = {
  fresh: 'Synced 2h ago',
  aging: 'Synced 2d ago',
  stale: 'Synced 5d ago, tap to refresh',
  syncing: 'Syncing…',
};

const OfferCard: React.FC<OfferCardProps> = ({
  merchant, logo, category, value, freshness, expiresIn, expiringSoon, saved, onToggleSave,
}) => {
  const dotState = freshness === 'syncing' ? 'syncing' : freshness;
  return (
    <div className={`cache__offercard cache__offercard--${freshness}`}>
      <div className="cache__offercard-top">
        <span className={`cache__deck-tag cache__deck-tag--${category}`}>{category}</span>
        <button
          type="button"
          className={`cache__offercard-save ${saved ? 'is-saved' : ''}`}
          onClick={onToggleSave}
          aria-pressed={!!saved}
          aria-label={saved ? 'Remove from saved offers' : 'Save this offer'}
        >
          ♥
        </button>
      </div>

      <div className="cache__offercard-brand">
        {logo && <img className="cache__offercard-logo" src={logo} alt="" aria-hidden="true" />}
        <div className="cache__offercard-merchant">{merchant}</div>
      </div>

      {freshness === 'syncing' ? (
        <div className="cache__offercard-shimmer" aria-hidden="true" />
      ) : (
        <div className="cache__offercard-value">{value}</div>
      )}

      <div className="cache__offercard-footer">
        <span className={`cache__deck-dot cache__deck-dot--${dotState}`} aria-hidden="true" />
        <span className="cache__offercard-freshlabel">{FRESH_LABEL[freshness]}</span>
        {expiresIn && (
          <span className={`cache__offercard-expiry ${expiringSoon ? 'is-expiring' : ''}`}>{expiresIn}</span>
        )}
      </div>
    </div>
  );
};

export default OfferCard;
